import React from 'react';
import { Cloud, Sun, Bird, House, Star, Balloon, Flower } from './Decor';

const Hero = () => {
  return (
    <section id="top" className="relative overflow-hidden bg-sky-soft pt-24 pb-0">
      {/* Sky decorations */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-10 right-16 animate-twinkle"><Sun size={140} /></div>
        <Cloud size={260} className="absolute top-20 left-[-40px] animate-cloud" />
        <Cloud size={220} className="absolute top-32 right-[8%] animate-cloud-rev" tone="#f6fbff" />
        <Cloud size={180} className="absolute top-[38%] left-[15%] animate-cloud opacity-90" />
        <Cloud size={200} className="absolute top-[46%] right-[10%] animate-cloud-rev opacity-95" />
        <Cloud size={300} className="absolute bottom-[-30px] left-[-60px] animate-cloud" />
        <Cloud size={260} className="absolute bottom-[10px] right-[-40px] animate-cloud-rev" />

        <div className="absolute top-24 left-[10%] animate-bird"><Bird size={90} /></div>
        <div className="absolute top-[30%] right-[24%] animate-bird" style={{ animationDelay: '0.6s' }}>
          <Bird size={70} flip />
        </div>

        <Star size={26} className="absolute top-24 left-[42%] animate-twinkle" />
        <Star size={22} className="absolute top-40 right-[38%] animate-twinkle" color="#ffb27a" />
        <Star size={20} className="absolute top-[54%] left-[8%] animate-twinkle" color="#a8d97e" />

        <Flower size={70} className="absolute top-[60%] left-[6%] animate-float" color="#f8c1c1" />
        <Flower size={54} className="absolute top-[68%] right-[7%] animate-float" color="#ffd6a5" />

        <div className="absolute top-[46%] left-[4%] animate-float">
          <Balloon color="#ef7a3d" size={70} />
        </div>
        <div className="absolute top-[42%] right-[3%] animate-float" style={{ animationDelay: '1s' }}>
          <Balloon color="#7ec2d4" size={64} />
        </div>
      </div>

      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 min-h-[92vh] flex flex-col items-center justify-start pt-10">
        {/* Big brush heading */}
        <div className="text-center animate-fade-up">
          <div className="font-hand text-[15px] tracking-[0.35em] text-[#3aa9b7] mb-3">SELAMAT DATANG DI</div>
          <h1 className="font-brush text-[68px] md:text-[112px] leading-[0.9] text-[#2b8b98] drop-shadow-[0_4px_0_rgba(0,0,0,0.05)]">
            TK MELATI ASRI
          </h1>
          <div className="mt-6 flex justify-center">
            <div className="ribbon animate-ribbon font-brush text-[28px] md:text-[34px]">
              Sekolah Ceria untuk Bunga-bunga Kecil!
            </div>
          </div>
          <p className="mt-8 max-w-[620px] mx-auto font-hand text-[18px] text-[#4a3b2a]/85">
            Tempat bermain, belajar, dan bertumbuh untuk anak usia 2-6 tahun.
            Bersama guru yang penuh kasih, di lingkungan yang aman dan menyenangkan.
          </p>
        </div>

        {/* Big house */}
        <div className="relative mt-6 md:mt-2 w-full max-w-[900px] animate-fade-up" style={{ animationDelay: '0.15s' }}>
          <House size={900} className="w-full h-auto" />
          <div className="absolute -top-10 -left-6 animate-bird">
            <Bird size={70} />
          </div>
        </div>

        {/* Bottom cloud ridge */}
        <div className="absolute bottom-0 left-0 right-0 h-24 md:h-32" style={{
          background: 'linear-gradient(180deg, transparent, rgba(255,255,255,0.9) 70%, #ffffff)',
        }} />
      </div>
    </section>
  );
};

export default Hero;
